import React, { Fragment } from 'react';
import cloneDeep from 'lodash.clonedeep';
import i18n from 'i18n';
import { TargetModel } from 'data/target/target.types';
import TargetDetails from '../../targets/forms/target-details';
import { ChangedField } from '../../../shared/form';

export const shouldShowTarget = (target: TargetModel | null, hideEmptyTargets: any): boolean => {
  if (target == null) {
    return false;
  }

  if (hideEmptyTargets && (target.primaryValue == null || target.primaryValue === '')) {
    return false;
  }
  return true;
};

export default class TargetsSummaryOfTargetPanel extends React.Component<any, any> {
  targetRefs:any[] = [];

  targetFieldUpdateHandler = (changedField: ChangedField, key: string, targets: any[], updateOnlyTarget?: boolean) => {
    const {
      name, value, label, valueLabel,
    } = changedField;

    const newTargets = targets.slice();
    const newTarget = newTargets.find((target:any) => { return target.primaryType === key; });
    // Track target change
    if (this.props.changeTracker && newTarget) {
      const oldValue = this.getTargetValue(newTarget, name);
      this.props.changeTracker.addUpdated(`case.${this.props.warrantCase.id}.target.${newTarget.id}`, valueLabel, label, oldValue);
    }
    this.customModifyTargetOutputByType(newTarget, name, value);
    if (!updateOnlyTarget) {
      this.props.caseDetailsFieldUpdateHandler(changedField);
    }
  }

  getTargetValue = (target: any, name: string) => {
    if (name === 'options') {
      return target[name]?.[0]?.value ?? '';
    }

    return target[name];
  }

  customModifyTargetOutputByType = (target: any, name: string, value: any) => {
    if (name === 'options') {
      if (typeof value === 'object') {
        target[name] = Object.keys(value).map((key: string) => ({ key, value: value[key] }));
      } else {
        target[name][0].value = value;
      }
    } else {
      target[name] = value;
    }
  }

  areTargetsValid = (forceTouched = true) => {
    let areTargetValid = true;
    this.targetRefs.forEach((targetRef: any) => {
      if (targetRef) {
        const isTargetValid = targetRef.isTargetValid(forceTouched);
        areTargetValid = areTargetValid && isTargetValid;
      }
    });
    return areTargetValid;
  }

  handleClick = (event:any, target:any) => {
    // This line is needed to fix DX-983
    event.preventDefault();
    this.props.handleClick(target);
  }

  static targetFieldWithDisabledAccessFunction = (field:any) => {
    const fieldClone = cloneDeep(field);

    fieldClone.subFields.primaryValue.disabled = true;

    if (fieldClone.subFields.options) {
      fieldClone.subFields.options.disabled = true;
    }

    return fieldClone;
  };

  // shouldShowTarget(target: TargetModel | null, hideEmptyTargets: any): boolean {
  //   // const {
  //   //   hideEmptyTargets,
  //   // } = this.props;

  //   if (target == null) {
  //     return false;
  //   }

  //   if (hideEmptyTargets && (target.primaryValue == null || target.primaryValue === '')) {
  //     return false;
  //   }

  //   return true;
  // }

  render(): JSX.Element {
    const {
      targetFields,
      selectedTarget,
      targets,
      warrantCase,
      changeTracker,
      targetDomainList,
      currentStateMode,
      hideEmptyTargets
    } = this.props;

    return (
      <Fragment>
        <div className="section-header">
          {i18n.t('warrant.target.form.targets')}
        </div>
        <p className="instruction-text">
          {i18n.t('warrant.target.form.selectTarget')}
        </p>
        {targetFields && (
          <div className="targetSummaryOfTargetPanelTargetsList" data-testid="TargetSummaryOfTargetPanelTargetsList">
            {
              Object.keys(targetFields).map((key: any, index: number) => {
                const target = targets.find((t:any) => {
                  return t.primaryType === key;
                });

                if (!shouldShowTarget(target, hideEmptyTargets)) {
                  return (<Fragment key={key} />);
                }

                return (
                  <div
                    key={target.id}
                    onClick={(event:any) => { this.handleClick(event, target); }}
                  >
                    <div className={selectedTarget?.id === target.id ? 'selectedclass' : ''}>
                      <TargetDetails
                        key={target.id}
                        ref={(ref:any) => { this.targetRefs.push(ref); }}
                        formId={`${target.primaryType}_${warrantCase.id}${warrantCase.cfId ? warrantCase.cfId : ''}${target.id}`}
                        target={cloneDeep(target)}
                        targetField={
                          TargetsSummaryOfTargetPanel.targetFieldWithDisabledAccessFunction(targetFields[key])
                        }
                        changeTracker={changeTracker}
                        fieldUpdateHandler={(changedField: ChangedField, updateOnlyTarget?: boolean) => {
                          this.targetFieldUpdateHandler(
                            changedField,
                            key,
                            targets.slice(),
                            updateOnlyTarget,
                          );
                        }}
                        targetDomainList={targetDomainList}
                        mode={currentStateMode}
                        allowedTargetsToSetOptions={this.props.allowedTargetsToSetOptions}
                      />
                    </div>
                  </div>
                );
              })
            }
          </div>
        )}
      </Fragment>
    );
  }
}
